function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "v9lhxh8iuc",
  x1: "35.152%",
  x2: "121.5%",
  y1: "100.505%",
  y2: "-100.5%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#6A2D87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A93D69"
}));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#v9lhxh8iuc)",
  d: "M 32.139,6.862 H 6.862 c -1.738,0 -3.144,1.42 -3.144,3.16 L 3.702,28.978 c 0,1.738 1.422,3.16 3.16,3.16 h 25.277 c 1.738,0 3.16,-1.422 3.16,-3.16 V 10.022 c 0,-1.738 -1.422,-3.16 -3.16,-3.16 z m 0,6.319 -12.639,7.9 -12.639,-7.9 v -3.16 l 12.64,7.9 12.638,-7.9 z"
});
const SvgIcEmail = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 39,
  height: 39,
  viewBox: "0 0 39 39",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-email.972d3afc.svg";
export { ForwardRef as ReactComponent };